export async function base64FromPath(path) {
    const response = await fetch(path);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader;
        reader.onerror = reject;
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            }
            else {
                reject('method did not return a string');
            }
        };
        reader.readAsDataURL(blob);
    });
}
//# sourceMappingURL=utils.js.map